import AzureStorage from "@/assets/libs/azure-storage.blob";
import PsStore from "@/assets/libs/ps-storage";

export default {
  service: null,
  serviceGet(userMedia=null) {
    if(this.service == null) {
      if(process.env.VUE_APP_STORAGE_MODE == 'ps-storage'){
        this.service = PsStore.createService(
          userMedia ? process.env.VUE_APP_PSSTORAGE_USERMEDIA_URL : process.env.VUE_APP_PSSTORAGE_URL
        );
      }
      else {
        this.service = AzureStorage.createBlobServiceWithSas(
          userMedia ? process.env.VUE_APP_USERMEDIA_BLOBURI : process.env.VUE_APP_CDN_BLOBURI, 
          userMedia ? process.env.VUE_APP_USERMEDIA_SASTOKEN : process.env.VUE_APP_CDN_SASTOKEN
        );
      }
    }
    return this.service;
  },
  updateFile(file,container, name = false) { 
    let containerName;
    let userMedia = null;
    if(container == 'activity') {containerName = process.env.VUE_APP_CDN_ACTIVITY_CONTAINERNAME; userMedia=true}
    else if(container == 'content') {containerName = process.env.VUE_APP_CDN_CONTENT_CONTAINERNAME}
    else if(container == 'user') {containerName = process.env.VUE_APP_CDN_LEARNINGUSER_CONTAINERNAME}
    else if(container == 'foroComment') {containerName = process.env.VUE_APP_CDN_FOROCOMMENT_CONTAINERNAME; userMedia=true}
    
    const blobService = this.serviceGet(userMedia);
    const nameForBlob = !name
      ? this.generateUuid() + "." + file.name.split(".").pop()
      : name + "." + file.name.split(".").pop();
    
    // const customBlockSize = file.size > 1024 * 1024 * 32 ? 1024 * 1024 * 4 : 1024 * 512;
    // blobService.singleBlobPutThresholdInBytes = customBlockSize;

    return new Promise((resolve, reject) => {
      // blobService.createBlockBlobFromBrowserFile(process.env.VUE_APP_CDN_CONTAINERNAME, nameForBlob, file, {blockSize : customBlockSize}, 
      blobService.createBlockBlobFromBrowserFile(containerName, nameForBlob, file, 
        (error, result) => {
          console.log(error);
          if (error) {
            reject(error.message)
          } else {
            resolve(result.name)
          }
      });
    })
  },
  generateUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}